import React, { Component } from 'react'
import _ from 'lodash'

import datastore from '../../../datastore'
import Loading from '../../../components/common/Loading'
import { hackToParseMetaJson } from '../../../common/util'
import { DEFAULT_ADDRESS, DEFAULT_LOGO_URL } from '../../../common/const'
import './printable.css'

export default class PrintableQcSummary extends Component {
    count = 2
    state = {
        product: null,
        inspection: null,
        project: null,
    }

    componentWillMount() {
        const productId = this.props.params.productId
        const inspectionId = this.props.params.inspectionId
        datastore.product.getProduct(productId)
            .then(product => {
                const inspection = _.find(product.inspections, ['id', inspectionId])
                this.setState({
                    product: product,
                    inspection: inspection
                })
            })

        datastore.user.getProfile()
            .then(res => {
                this.setState({
                    project: res.current_project
                })
            })
    }

    render() {
        if (!this.state.product || !this.state.project) {
            return <Loading />
        }

        const meta = this.state.project.meta_json ? hackToParseMetaJson(this.state.project.meta_json) : null

        const address = meta && meta.branch_address ? meta.branch_address : DEFAULT_ADDRESS
        const logoUrl = meta && meta.branch_logo_url ? meta.branch_logo_url : DEFAULT_LOGO_URL

        const groupedDefects = _.groupBy(this.state.inspection.defects, 'location')
        return <div>
            { Object.entries(groupedDefects).map(([location, defects]) => {
                const originalCount = this.count
                this.count += Math.ceil(defects.length / 6)
                return <PerLocation 
                    key={ location }
                    generalInfo={ this.state.inspection }
                    defects={ defects }
                    skuCode={ this.state.product.orderingSkuCode }
                    buildingId={ this.state.product.buildingId }
                    location={ location }
                    count={ originalCount }
                    projectName={ this.state.product.projectName }
                    address={ address }
                    logo={ logoUrl }
                />
            })}
        </div>
    }
}

const COUNT_PER_PAGE = 3
const PerLocation = ({ generalInfo, defects, skuCode, buildingId, location, count, projectName, address, logo }) => {
    const grouped = defects.reduce((acc, item, index) => {
        if (index % COUNT_PER_PAGE === 0) {
            // Start new group.
            acc.push([])
        }

        const page = acc[acc.length-1]
        page.push(item)

        return acc
    }, [])

    return <div>
        { grouped.map((page, index) => {
            return <PerPage
                key={ index }
                generalInfo={ generalInfo }
                defects={ page }
                skuCode={ skuCode }
                buildingId={ buildingId }
                location={ location }
                count={ count + index }
                projectName={ projectName }
                address={ address }
                logo={ logo }
            />
        })}
    </div>
}

const PerPage = ({ generalInfo, defects, skuCode, buildingId, location, count, projectName, address, logo }) => {
    const newLineIndex = address.indexOf('เขต')
    const addressLine1 = address.slice(0, newLineIndex)
    const addressLine2 = address.slice(newLineIndex)

    return <div className="a4">
        <div className="print-container">
            <div>
                <div className="header-section">
                    <div>
                        <p className="h1">{ projectName }</p>
                        <p className="h2">ห้อง { skuCode }</p>
                        <table className="header-info">
                            <tbody>
                                <tr>
                                    <td>ครั้งที่ตรวจ: { generalInfo.inspectionNo }</td>
                                    <td>วันที่ตรวจ: { generalInfo.inspectionDate.split(' ')[0] }</td>
                                </tr>
                                <tr>
                                    <td>ผู้ตรวจ: { generalInfo.staffName }</td>
                                    <td>ช่าง: { generalInfo.engineerName }</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <img alt="" src={logo} className="logo-project" />
                </div>
                <div className="content-section">
                    <p className="defect-header h1">{ location }</p>
                    <table className="defect-table">
                        <tbody>
                            { defects.map((row, rowIndex) => {
                                return <tr key={rowIndex}>
                                    <td className="defect-info before">
                                        <img alt="" src={ row.before } className="defect-picture"/>
                                        <p>{ row.title } (ก่อน)</p>
                                    </td>
                                    <td className="defect-info after">
                                        <img alt="" src={ row.after } className="defect-picture"/>
                                        <p>{ row.title } (หลัง)</p>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            <div>
                <div className="footer">
                    <img alt="" src={logo} className="logo-project"/>
                    <p className="footer-text">{ addressLine1 }<br />
                        { addressLine2 }
                    </p>
                </div>
                <p className="page-num">{count}</p>
            </div>
        </div>
    </div>
}
